import { Controller } from "@hotwired/stimulus"

// Toggles a language selector dropdown. Close on outside click or ESC.
// Targets: trigger, panel
export default class extends Controller {
  static targets = ["trigger", "panel"]

  connect() {
    this.boundCloseOnClickOutside = this.closeOnClickOutside.bind(this)
    this.boundCloseOnEsc = this.closeOnEsc.bind(this)
    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", "false")
      this.triggerTarget.setAttribute("aria-haspopup", "true")
    }
  }

  disconnect() {
    this.removeListeners()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    if (this.isOpen()) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    if (!this.hasPanelTarget) return
    this.panelTarget.classList.remove("hidden")
    if (this.hasTriggerTarget) this.triggerTarget.classList.add("!bg-gray-200")
    this.syncAriaExpanded(true)
    document.addEventListener("click", this.boundCloseOnClickOutside)
    document.addEventListener("keydown", this.boundCloseOnEsc)
  }

  close(_event) {
    if (!this.hasPanelTarget) return
    this.panelTarget.classList.add("hidden")
    if (this.hasTriggerTarget) this.triggerTarget.classList.remove("!bg-gray-200")
    this.syncAriaExpanded(false)
    this.removeListeners()
  }

  closeOnClickOutside(event) {
    if (this.element.contains(event.target)) return
    this.close()
  }

  closeOnEsc(event) {
    if (event.key === "Escape") {
      event.preventDefault()
      this.close()
    }
  }

  removeListeners() {
    document.removeEventListener("click", this.boundCloseOnClickOutside)
    document.removeEventListener("keydown", this.boundCloseOnEsc)
  }

  isOpen() {
    return this.hasPanelTarget && !this.panelTarget.classList.contains("hidden")
  }

  syncAriaExpanded(open) {
    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", String(open))
    }
  }
}
